var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-block"},[_c('b-container',[_c('page-editor',{attrs:{"alias":'svo'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }